require('./cardR42TravelPlusModal.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;
const moment = require('moment');

// @commons
const OKModal = require('commonsComponents/OKModal');
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

// @utilities
const { getLastNChars, nonNumericFilter } = require('utilities/stringHelper');

// @constants
const {
    R42_CARD_OFF,
    R42_CARD_ON,
    R42_CARD_PENDING_DEACTIVATION,
    R42_CARD_VIP,
    R42_CARD_IS_NOT_ACTIVED
} = require('constants/cardR42States');
const { TRAVEL_PLUS_HIRE } = require('constants/operationTypes');
const {
    DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR, TYPE_CONTRACT_MASTERCARD, CREDIT_CARD_SUBTYPE_DIAMOND
} = require('constants/index');
const bannerTravelPlusImage = require('assets/images/banner-travel-plus.jpg');

class CardR42TravelPlusModal extends React.Component {
    constructor(props) {
        super(props);

        this.handlePrimaryButton = this.handlePrimaryButton.bind(this);
    }

    componentDidUpdate(prevProps) {
        const {
            hireTravelPlusCCWrapUpOffStart,
            hireTravelPlusCCWrapUpOnStart,
            immCard,
            isOpen,
        } = this.props;
        const immTravelPlus = immCard.get('travelPlus');
        const status = immTravelPlus.get('status');

        if (__CONTACT_CENTER__ && !immTravelPlus.get('error') && !prevProps.isOpen && isOpen) {
            //This actions are only for Contact Center wrap up purpose
            if (status === R42_CARD_OFF || status === R42_CARD_PENDING_DEACTIVATION) {
                hireTravelPlusCCWrapUpOnStart();
            } else if (status === R42_CARD_ON) {
                hireTravelPlusCCWrapUpOffStart();
            }
        }
    }

    buildCategories() {
        const { immCard } = this.props;
        const type = immCard.getIn(['product', 'type']);
        const subType = immCard.getIn(['product', 'subtype']);
        const openDebitMastercard = type === TYPE_CONTRACT_MASTERCARD && subType === CREDIT_CARD_SUBTYPE_DIAMOND

        const categories = [{
            description: 'travelPlusPurchase-travelPlusPurchase_freeComissionDescription',
            icon: 'icon-comercio-tiendas',
            title: 'travelPlusPurchase-travelPlusPurchase_freeComissionTitle',
        }, {
            icon: 'icon-diversificacion',
            title: 'travelPlusPurchase-travelPlusPurchase_freeConversionTitle',
            description: 'travelPlusPurchase-travelPlusPurchase_freeConversionDescription',
        },
        ...(openDebitMastercard ? [] : [{
            icon: 'icon-seguro-accidentes',
            title: 'travelPlusPurchase-travelPlusPurchase_freeSafeTitle',
            description: 'travelPlusPurchase-travelPlusPurchase_freeSafeDescription',
        }]), {
            description: openDebitMastercard ? 'travelPlusPurchase-travelPlusPurchase_freeCashTitleMastercard' : 'travelPlusPurchase-travelPlusPurchase_freeCashDescription',
            icon: 'icon-cajero',
            title: 'travelPlusPurchase-travelPlusPurchase_freeCashTitle',
        }];
        const categoryList = categories.map((category, index) => {
            return (
                <div key={index} className="card-r42-travel-plus-modal__category">
                    <div className="card-r42-travel-plus-modal__category-column">
                        <div className="card-r42-travel-plus-modal__category-column-icon">
                            <i className={category.icon} />
                        </div>
                    </div>
                    <div className="card-r42-travel-plus-modal__category-column">
                        <h5 className="card-r42-travel-plus-modal__category-column-title">
                            <FormattedText value={category.title} />
                        </h5>
                        <div className="card-r42-travel-plus-modal__category-column-description">
                            <FormattedText value={category.description} />
                        </div>
                    </div>
                </div>
            )
        });
        return (
            <div className="card-r42-travel-plus-modal__categories">
                {categoryList}
            </div>
        );
    }

    buildPriceBox() {
        const {
            immCard,
            immGlobalVariables,
            subtypeCriteria,
            standCriteria,
            productContract,
            vip
        } = this.props;
        const status = this.getTravelPlusStatus();
        const price = immGlobalVariables.getIn(['variables', 'parameters', 'travel_plus', 'precio']);
        const priceDefaultPoeKey = formatText(`travelPlusPurchase-travelPlusPurchase_defaultPrice`);
        const pricePoeKey = formatText(`travelPlusPurchase-travelPlusPurchase_${productContract}_${subtypeCriteria}_${standCriteria}Price`);

        const getPoeKey = () => {
            switch (true) {
                case pricePoeKey !== '####':
                    return pricePoeKey;
                case priceDefaultPoeKey !== '####':
                    return priceDefaultPoeKey;
                default:
                    return price;
            }
        }
        let content;

        if (vip) {
            content = (
                <div className="card-r42-travel-plus-modal__price-box">
                    <span className="card-r42-travel-plus-modal__free-price">
                        {getPoeKey()}
                    </span>
                    <span className="card-r42-travel-plus-modal__per-month">
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_byMonth" />
                    </span>
                    <div className="card-r42-travel-plus-modal__price">
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_freePrice" />
                    </div>
                </div>
            );
        } else {
            let fromTranslate = <FormattedText value="travelPlusPurchase-travelPlusPurchase_fromYouActiveTravel" />;
            if (status === R42_CARD_PENDING_DEACTIVATION) {
                const date = moment(immCard.getIn(['travelPlus', 'subscriptionDate'])).add(1, 'days').format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR);
                fromTranslate = (

                    <FormattedText
                        injectedStrings={[date]}
                        value="travelPlusPurchase-travelPlusPurchase_fromYouActiveTravelDate"
                    />

                );
            }
            content = (
                <div className="card-r42-travel-plus-modal__price-box">
                    <div className="card-r42-travel-plus-modal__date-text">
                        {fromTranslate}
                    </div>
                    <div className="card-r42-travel-plus-modal__price"> {getPoeKey()} </div>
                    <div className="card-r42-travel-plus-modal__bold">
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_byMonth" />
                    </div>
                </div>
            );
        }

        return content;
    }

    buildSignaturePatternContent() {
        const {
            immCard,
        } = this.props;
        const status = this.getTravelPlusStatus();
        const pan = nonNumericFilter(immCard.get('number'));
        const operationParams = {
            pan,
        };

        let signaturePatternContent;

        if (status !== R42_CARD_VIP) {
            signaturePatternContent = (
                <div className="card-r42-travel-plus-modal__signature-pattern">
                    <SignaturePattern
                        operationParams={operationParams}
                        operationType={TRAVEL_PLUS_HIRE}
                    />
                </div>
            );
        }

        return signaturePatternContent;
    }

    getAliasName() {
        const { immCard } = this.props;
        return `${immCard.getIn(['alias', 'current'])} ${getLastNChars(immCard.get('number'), 4)}`;
    }

    getTravelPlusStatus() {
        const {
            forceVipBehavior,
            immCard,
        } = this.props;

        return forceVipBehavior ? R42_CARD_VIP : immCard.getIn(['travelPlus', 'status']);
    }

    buildVIPModalMessage(vipFeeMessage, vipFeeMessageDate) {
        let date;

        if (!!vipFeeMessageDate) {
            date = formatText(vipFeeMessageDate);
        }

        return (
            <div className="card-r42-travel-plus-modal__message">
                <OKMessage type="informative">
                    <FormattedText
                        value="cardR42TravelPlusModal-cardR42TravelPlusModal_yourServiceActiveAndFree1"
                    />
                    &nbsp;
                    <FormattedText
                        className="card-r42-travel-plus-modal__bold"
                        value={vipFeeMessage}
                    />
                    &nbsp;
                    {date}
                </OKMessage>
            </div>
        );
    }

    buildContent() {
        const { immCard, vip, descIntervenciones } = this.props;
        const status = this.getTravelPlusStatus();

        const cardName = this.getAliasName();
        const categories = this.buildCategories();
        const priceBox = this.buildPriceBox();
        let description = null;
        if (descIntervenciones) {

            description = (
                <p className="card-r42-travel-plus-modal__description">

                    <FormattedText value="travelPlusPurchase-travelPlusPurchase_description" />
                </p>
            );
        }
        let content;
        if (vip) {
            let upperMessage;
            let lowerMessage;

            if (immCard.get('isNerudaCard')) {
                description = null;
                upperMessage = this.buildVIPModalMessage('cardR42TravelPlusModal-cardR42TravelPlusModal_yourServiceActiveAndFree3',
                    'cardR42TravelPlusModal-cardR42TravelPlusModal_yourServiceActiveAndFreeDate');
            } else {
                lowerMessage = this.buildVIPModalMessage('cardR42TravelPlusModal-cardR42TravelPlusModal_yourServiceActiveAndFree2');
            }

            content = (
                <React.Fragment>
                    <h4 className="card-r42-travel-plus-modal__title">
                        <FormattedText
                            injectedStrings={[cardName]}
                            value="cardR42TravelPlusModal-cardR42TravelPlusModal_enjoyTravelPlusFree"
                        />
                    </h4>
                    {description}
                    {priceBox}
                    {upperMessage}
                    {categories}
                    {lowerMessage}
                </React.Fragment>
            );
        } else if ([R42_CARD_OFF, R42_CARD_PENDING_DEACTIVATION, R42_CARD_IS_NOT_ACTIVED].includes(status)) {
            content = (
                <React.Fragment>
                    <h4 className="card-r42-travel-plus-modal__title">
                        <FormattedText
                            injectedStrings={[cardName]}
                            value={descIntervenciones ? "travelPlusPurchase-travelPlusPurchase_titleTurnOn" : "travelPlusPurchase-travelPlusPurchase_titleToggleBeneficiaries"}
                        />
                    </h4>
                    {description}
                    {priceBox}
                    {categories}
                </React.Fragment>
            );
        } else if (status === R42_CARD_ON) {
            content = (
                <React.Fragment>
                    <h4 className="card-r42-travel-plus-modal__title">
                        <FormattedText
                            injectedStrings={[cardName]}
                            value={descIntervenciones ? "travelPlusPurchase-travelPlusPurchase_titleTurnOff" : "travelPlusPurchase-travelPlusPurchase_titleToggleBeneficiaries"}

                        />
                    </h4>
                    {description}
                    {categories}
                    {descIntervenciones && (

                        <div className="card-r42-travel-plus-modal__message">
                            <OKMessage type="informative">
                                <FormattedText
                                    value="cardR42TravelPlusModal-cardR42TravelPlusModal_advantagesWillBeDate"
                                />
                            </OKMessage>
                        </div>
                    )}
                </React.Fragment>
            );
        }

        return (
            <div className="card-r42-travel-plus-modal">
                {content}
            </div>
        );
    }

    handlePrimaryButton() {
        const {
            immCard,
            setTravelPlus,
        } = this.props;
        setTravelPlus(immCard.get('cardId'));
    }

    buildErrorModalCanNotLoadContent() {
        const cardName = this.getAliasName();
        return (
            <div className="card-r42-travel-plus-modal">
                <i className="card-r42-travel-plus-modal__icon-error" />
                <h4 className="card-r42-travel-plus-modal__title">
                    <FormattedText
                        injectedStrings={[cardName]}
                        value="cardR42TravelPlusModal-cardR42TravelPlusModal_travelPlusCanNotLoadErrorTitle"
                    />
                </h4>
                <p className="card-r42-travel-plus-modal__description">
                    <FormattedText value="cardR42TravelPlusModal-cardR42TravelPlusModal_travelPlusCanNotLoadErrorDescription" />
                </p>
                <div className="card-r42-travel-plus-modal__message">
                    <OKMessage type="informative">
                        <FormattedText value="cardR42TravelPlusModal-cardR42TravelPlusModal_travelPlusCanNotLoadErrorMessage" />
                    </OKMessage>
                </div>
            </div>
        );
    }

    buildErrorModalContent() {
        return (
            <div className="card-r42-travel-plus-modal">
                <h4 className="card-r42-travel-plus-modal__title">
                    <FormattedText
                        value="cardR42TravelPlusModal-cardR42TravelPlusModal_travelPlusTurnOnOffErrorTitle"
                    />
                </h4>
                <p className="card-r42-travel-plus-modal__description">
                    <FormattedText
                        value="cardR42TravelPlusModal-cardR42TravelPlusModal_travelPlusTurnOnOffErrorDescription"
                    />
                </p>
            </div>
        );
    }

    buildSuccessModalContent() {
        const status = this.getTravelPlusStatus();
        const cardName = this.getAliasName();
        let title = 'cardR42TravelPlusModal-cardR42TravelPlusModal_travelPlusTurnOnCorrectly';
        let description = 'cardR42TravelPlusModal-cardR42TravelPlusModal_canTurnOffAnyTimeTravelPlus';

        if (status === R42_CARD_ON) {
            title = 'cardR42TravelPlusModal-cardR42TravelPlusModal_travelPlusTurnOffCorrectly';
            description = 'cardR42TravelPlusModal-cardR42TravelPlusModal_canTurnOnAnyTimeTravelPlus';
        }

        return (
            <div className="card-r42-travel-plus-modal">
                <h4 className="card-r42-travel-plus-modal__title">
                    <FormattedText
                        injectedStrings={[cardName]}
                        value={title}
                    />
                </h4>
                <p className="card-r42-travel-plus-modal__description">
                    <FormattedText value={description} />
                </p>
            </div>
        );
    }

    render() {
        const {
            immCard,
            immSignaturePattern,
            immTravelPlus,
            isOpen,
            onCloseCallback,
            vip,
            descIntervenciones
        } = this.props;
        const status = this.getTravelPlusStatus();
        const primaryButtonLoading = immTravelPlus.get('isFetching') || immSignaturePattern.get('isFetchingConfig');
        let signaturePatternContent;
        let content;
        let primaryButtonText = formatText('cardR42TravelPlusModal-cardR42TravelPlusModal_okTravelPlus');
        let onPrimaryButtonClick = onCloseCallback;
        let secondaryButtonText;
        let onSecondaryButtonClick = onCloseCallback;

        if (immCard.getIn(['travelPlus', 'error'])) {
            content = this.buildErrorModalCanNotLoadContent();
        } else {
            if (immTravelPlus.get('error') || immSignaturePattern.get('isFetchingConfigError')) {
                content = this.buildErrorModalContent();
            }
            else if (immTravelPlus.get('submitSuccessful')) {
                content = this.buildSuccessModalContent();
            }
            else if (!descIntervenciones && !vip) {
                content = this.buildContent();
                primaryButtonText = formatText('cardR42TravelPlusModal-cardR42TravelPlusModal_okTravelPlus');

            } else {
                content = this.buildContent();
                if ([R42_CARD_OFF, R42_CARD_PENDING_DEACTIVATION, R42_CARD_IS_NOT_ACTIVED].includes(status) && !vip) {
                    primaryButtonText = formatText('cardR42TravelPlusModal-cardR42TravelPlusModal_turnOnTravelPlus');
                    onPrimaryButtonClick = this.handlePrimaryButton;
                    secondaryButtonText = formatText('cardR42TravelPlusModal-cardR42TravelPlusModal_cancel');
                } else if (status === R42_CARD_ON && !vip) {
                    primaryButtonText = formatText('cardR42TravelPlusModal-cardR42TravelPlusModal_turnOffTravelPlus');
                    onPrimaryButtonClick = this.handlePrimaryButton;
                    secondaryButtonText = formatText('cardR42TravelPlusModal-cardR42TravelPlusModal_cancel');
                }
            }
        }

        if (status !== R42_CARD_VIP && !immCard.getIn(['travelPlus', 'error'])) {
            signaturePatternContent = this.buildSignaturePatternContent();
        }

        const contentWithSignaturePattern = (
            <React.Fragment>
                {content}
                {signaturePatternContent}
            </React.Fragment>
        );

        return (
            <OKModal
                content={contentWithSignaturePattern}
                contentOverflow="auto"
                footerType="navigation"
                headerContent={bannerTravelPlusImage}
                headerType="full-image"
                isOpen={isOpen}
                onCloseCallback={onCloseCallback}
                onPrimaryButtonClick={onPrimaryButtonClick}
                onSecondaryButtonClick={onSecondaryButtonClick}
                primaryButtonLoading={primaryButtonLoading}
                primaryButtonText={primaryButtonText}
                secondaryButtonText={secondaryButtonText}
                size="large"
            />
        );
    }
}

CardR42TravelPlusModal.propTypes = {
    forceVipBehavior: PropTypes.bool,
    hireTravelPlusCCWrapUpOffStart: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnStart: PropTypes.func.isRequired,
    immCard: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immTravelPlus: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseCallback: PropTypes.func.isRequired,
    setTravelPlus: PropTypes.func.isRequired,
};

CardR42TravelPlusModal.defaultProps = {
    forceVipBehavior: false,
};

module.exports = CardR42TravelPlusModal;

